// extracted by mini-css-extract-plugin
export default {"pagination":"AdminPagination_pagination__vkoIZ","left_slide":"AdminPagination_left_slide__nNlq-"};